import React from 'react'

const renderSelect = ({input, label, placeholder, tooltip, options=[], disabled, meta: {touched, error}}) => (
	<div>
		<span className="small">{label}</span>
		<select style={{color: input.value==='' ? '#a6acb1' : '#495057'}}className={"custom-select" + ((touched && error) ? " invalid": "")} {...input} disabled={disabled}>
			{placeholder && <option value="" disabled>{placeholder}</option>}
			{options.map(selectOption =>
			<option style={{color: '#495057'}} value={selectOption} key={selectOption}>{selectOption}</option>)}
		</select>
		<span className="small tooltip-text">{tooltip}</span>
		{touched && error && (error!=="Required") &&<div className="error">{error}</div>}
	</div>
)

export default renderSelect


// WEBPACK FOOTER //
// ./src/components/fields/renderSelect.js